import { render, staticRenderFns } from "./end.vue?vue&type=template&id=63e58dfa&scoped=true&"
import script from "./end.vue?vue&type=script&lang=js&"
export * from "./end.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e58dfa",
  null
  
)

export default component.exports